import React, { useState, useEffect, Children, useRef, ReactNode, useCallback } from "react";
import {
  Col,
  Row,
  Menu,
  MenuProps,
  Avatar,
  Divider,
  Tooltip,
  Button,
  Flex,
  Tabs,
  Segmented,
  List,
  Skeleton,
  TreeSelect,
  Layout,
  Typography,
  Space,
} from "antd";
import {
  AppstoreOutlined,
  BellOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  ContactsOutlined,
  FilterOutlined,
  MailOutlined,
  MessageOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import MessageListItem from "./MessageListItem/MessageListItem";
import ScrollableLoadMore from "../ScrollableLoadMore";
import { useStore } from "../../inbox-store";


interface MessageListProps {
  conversations: any[];
  retrieveConversations: () => Promise<void>;
}

const MessageList= ({companyId,filters,conversations,retrieveConversations}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [page,setPage] = useState(1)
  const [pageSize,setPageSize] = useState(15)
  const [eol,setEol] = useState(true) // Start with true to prevent InfiniteScroll from calling loadMoreData on mount

  const loadMoreData = () => {
    if (loading) return;
  console.log('messageList: loadmoredata',page,pageSize)
    setLoading(true);
    retrieveConversations(companyId,filters,page,pageSize)
    .then((eol) =>{
      setEol(eol)
      setPage(page+1) 
      setLoading(false)
    });

  };

  useEffect(()=>{
    if(filters === null) return;
    
    console.log("changed company or filters:", {companyId, filters})
    setPage(1)
    setEol(false)
    setLoading(true);
    // Call retrieveConversations directly with page=1 to ensure correct page number
    retrieveConversations(companyId, filters, 1, pageSize)
    .then((eol) => {
      setEol(eol)
      setPage(2) // Set to 2 for next load
      setLoading(false);
    });
  },[companyId, filters])

  // Archive / unarchive removed rows from this view (see inbox-store
  // requestListReload). Restart paging from page 1: the server offsets have
  // shifted, and an emptied list never scrolls so InfiniteScroll would never
  // request the next page on its own.
  const listReloadToken = useStore((s) => s.listReloadToken);
  useEffect(() => {
    if (listReloadToken === 0 || filters === null) return;
    setPage(1);
    setEol(false);
    setLoading(true);
    retrieveConversations(companyId, filters, 1, pageSize)
    .then((eol) => {
      setEol(eol);
      setPage(2);
      setLoading(false);
    });
  }, [listReloadToken]);


  const messageListLoader = (
    <div style={{ padding: '0' }}>
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '12px 8px',
            borderBottom: '1px solid #E6E6E6',
          }}
        >
            <Skeleton.Input
              active
              size="large"
              style={{ width: '100%', height: 24, marginBottom: 8 }}
            />

            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 8 }}>
              <Skeleton.Avatar active size={20} style={{ zIndex: 3 }} />
              <Skeleton.Avatar active size={20} style={{ marginLeft: -8, zIndex: 2 }} />
              <Skeleton.Avatar active size={20} style={{ marginLeft: -8, zIndex: 1 }} />
            </div>
        </div>
      ))}
    </div>
  );

  return (
    <ScrollableLoadMore items={[...conversations]} loadMoreData={loadMoreData} endOfListReached={eol} itemComponent={MessageListItem} loader={messageListLoader}/>
  );
};
export default MessageList;
